import * as React from "react";
import NavItem from "./navitem";
import "./navbar.scss";
import Hamburger from "../hamburger/hamburger";
import RedLogo from "../SVG/RedLogo";

function linkFactory(to,name){
    return {to,name}
}

export default function NavBar ({open,color,handleClick,current}){
    let isOpen = open ? "open" : "closed";
    let links = [
        linkFactory("/","home"),
        linkFactory("/illustration","illustration"),
        linkFactory("/design","design"),
        linkFactory("/about","about"),
        linkFactory("/contact","contact")
    ]
    return (
        <nav className={`nav ${isOpen}`}>
            <Hamburger
                color={color}
                open={open}
                onClick={handleClick}
            />
            <div className="logo-area">
                <NavItem to={"/"}>
                    <RedLogo className={"logo"}/>
                </NavItem>
            </div>
            <ul className={`${isOpen}`}>
                {/* We want to iterate over the list and remove the current page and create nav items*/}
                {links.map(({to,name},index)=>{
                    if(name === current){
                        return null;
                    }
                    return <NavItem key={index} name={name} to={to}></NavItem>
                })}

                {/*<NavItem to={"/"} name={"home"}/>*/}
                {/*<NavItem to={"/illustration"} name={"illustration"}/>*/}
                {/*<NavItem to={"/design"} name={" design "}/>*/}
                {/*<NavItem to={"/about"} name={"about"} />*/}
                {/*<NavItem to={"/contact"} name={"contact"} />*/}
            </ul>
        </nav>
    )
}
